import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "",
      title: "Certifications",
      place: "PMI Agile Certified Practitioner (PMI-ACP), Certified Scrum Master (CSM) Certified, Internet Web JavaScript Specialist ",
      desc: "",
    },
    {
      yearRange: "2011",
      title: "Masters in Business Administration",
      place: "Periyar University - Salem, India",
      desc: "Completed my Master in Business Administration from Periyar University - Salem, India.",
    },
    {
      yearRange: "2007",
      title: "Bachelor in Information Technology",
      place: "Jawaharlal Nehru Technological University - Hyderabad, India",
      desc: "Completed my Bachelor in Information Technology from Jawaharlal Nehru Technological University - Hyderabad, India.",
    },
    // {
    //   yearRange: "2013 - 2014",
    //   title: "International Science",
    //   place: "Harvard University",
    //   desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    // },
  ];

  const experienceDetails = [
    {
      yearRange: "2023 - current",
      title: "Senior Engineer",
      place: "Walmart, Toronto",
      desc: "As a Senior Engineer, In this role I am responsible for design, create, manage and optimize web applications using React, Node.js, MongoDB, and other technologies.",
    },
    {
      yearRange: "2021 - 2023",
      title: "Senior Engineer",
      place: "Scotia Bank, Toronto",
      desc: "As a Senior Engineer, In this role I have led end to end features from design to deployment using React, Node.js, PostgreSQL, and other technologies.",
    },
    {
      yearRange: "2018 - 2021",
      title: "Senior Engineer",
      place: "Royal Bank of Canada, Toronto",
      desc: "As a Senior Engineer, In this role iam responsible for development of new features and maintenance of existing features using Angular, React, Node.js, PostgreSQL, and other technologies.",
    },
  ];

  const skills = [
    {
      name: "Web Design",
      percent: 65,
    },
    {
      name: "HTML, CSS, SCSS, Bootstrap",
      percent: 95,
    },
    {
      name: "JavaScript, Typescript",
      percent: 80,
    },
    {
      name: "React, Angular, Vue",
      percent: 80,
    },
    {
      name: "Redux, NgRx",
      percent: 80,
    },
    {
      name: "Node.js, Express, MongoDB, MySQL, PostgreSQL",
      percent: 70,
    },
    {
      name: "Git, Jira, Confluence",
      percent: 80,
    },
    {
      name: "AWS, Azure, Docker",
      percent: 60,
    },
  ];

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Profile</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A summary of my Profile
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5">
          {/* My Education */}
          <div className="col-lg-12 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} {value.yearRange && `/ ${value.yearRange}`}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
          {/* My Experience */}
          {/* <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div> */}
        </div>
        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">My Skills</h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div className="col-md-6 wow fadeInUp" key={index}>
                <p className="fw-500 text-start mb-2">
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div className="progress progress-sm mb-4">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        {/* <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-dark shadow-none rounded-0"
            href={resumeFile}
            download
          >
            Download CV
          </a>
        </p> */}
      </div>
    </section>
  );
};

export default Resume;
